import React, { useState, useEffect, useContext } from "react";
import { XBEcard } from "./XBEcard";
import { prepareData } from '../../data/cards';
import { XbeContext } from './CardsPage';




export function XBEfilteredCards(props) {
  const {
    language,
    filters = [],
    featured,
    limit,
    start,
    pa,
  } = {...props};


  let visibleCount = 0;

  const countAsVisible = () => {
    // setVisibleCount(visibleCount + 1)
  }


  const context = useContext(XbeContext);

  // useEffect(() => {
  //   console.log('props = ', props);
  //   debugger
  // })

  const applyGlobalFilter = (array, pa) => {

    if (pa) {
      return array
    } else {
      // debugger
      return array.filter(item=>(typeof item['website']) === 'object')
    }
  }

  return (<div
  id="cards"
  className={`x_home_solutions-grid ${featured ? 'x_home_solutions-grid--featured' : ''}`}>


      {context && applyGlobalFilter(context['cards'], pa).map((oneCard, ind)=> {
        if (
          (!limit || (limit && limit > ind)) &&
          (!start || (start && start < ind))
          // &&
          // checkIfCard(oneCard)
        ) {
          return <XBEcard
              pa={pa}
              language={language}
              key={`card_${ind}`}
              countAsVisible = {countAsVisible}
              filters={filters}
              ind={ind}
              shown={true}
              key={`card_${ind}`}
              appearance={featured ? 'l' : 'm'}
              {...oneCard}
            />
          } else {
          return null
          // return <XBEcard shown={false} key={`card_${ind}`} appearance={featured ? 'l' : 'm'} {...oneCard}/>
        }
      })}

  </div>);
}
